import { Button } from "@material-ui/core";
import { parse } from "query-string";
import React, { Fragment, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import { returnCodeErrorMessages } from "./config";

export function BankReaderCallbackView(props) {
  const { status } = useParams();
  const searchParams = parse(location.search);
  const { iban, returnCode } = searchParams;

  const jsxMessage = returnCode
    ? returnCodeErrorMessages[returnCode]
    : returnCodeErrorMessages.default;

  useEffect(() => {
    if (iban) {
      const messageData = `bankReaderWidget:${status}`;
      const event = new MessageEvent("message", {
        data: { msg: messageData, iban },
      });
      window.parent.dispatchEvent(event);
    }
  }, [iban]);

  return (
    <Fragment>
      {status === "ko" && (
        <div className="mt-5 ml-3 mr-3">
          {jsxMessage}
          <Link to="/bankreader-callback/cancel">
            <Button variant="contained" color="primary" onClick={() => {}}>
              OK
            </Button>
          </Link>
          <hr />
          <div className="col-12 text-center">
            <p style={{ opacity: "0.6" }}>
              Para cualquier duda puedes contactar con nosotros en
              hola@nemuru.com o llamando al <br />
              +932 200 612.
            </p>
          </div>
        </div>
      )}
    </Fragment>
  );
}
